import React, { useState, useEffect } from 'react';
import PropTypes from "prop-types";

import Autocomplete from '../autocomplete';
import DotsLoader from '../dotsLoader';
import Tooltip from '../tooltip';
import styles from './asyncAutocomplete.scss';

function AsyncAutocomplete({ inputValue, noElementFoundMessage, loadingMessage, suggestions, isLoading, isEmpty, apiBusinessException, ...optionalProps }) {

    const showNoElementFoundMessage = () => {
        return (isEmpty && !isLoading)
    }

    const showBusinessException = () => {
        return (isEmpty && !isLoading && apiBusinessException?.code)
    }

    return (
        <div className={showNoElementFoundMessage() ? (styles.asyncautocompletewrap + ' ' + styles.errorClass) : styles.asyncautocompletewrap} >
            {showBusinessException() ? (
                <>
                    <div className={styles.noElementInfoHeader}>
                    {apiBusinessException.title}
                    <Tooltip
                        parent={
                        <span className={styles.noElementInfoText}>
                            <i className="aeh-icon-outlined-info"></i>
                        </span>
                        }
                        content={apiBusinessException.message}
                    />
                    </div>
                </>
                ) : (
                <Autocomplete
                    {...optionalProps}
                    inputValue={inputValue}
                    suggestions={suggestions}
                    autoSelect={false}
                />
            )}
            {/* TODO: remove autoSelect hardcoding */}
            {isLoading && <DotsLoader text={loadingMessage} />}
            {showNoElementFoundMessage() && <span className={styles.noElementFoundMessage}>{noElementFoundMessage}</span>}
        </div>
    )
}

AsyncAutocomplete.defaultProps = {
    loadingMessage: "Please wait",
    noElementFoundMessage: "No results found.",
    autoComplete: "off"
};

AsyncAutocomplete.propTypes = {
    inputValue: PropTypes.string,
    noElementFoundMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    loadingMessage: PropTypes.string,
    isLoading: PropTypes.bool,
    isEmpty: PropTypes.bool,
}

export default AsyncAutocomplete
